import { Button, Center, Group, Loader, Stack, Title } from '@mantine/core';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useMissionDrones, useMissions } from '@/api/missions';
import { EmptyState } from '@/components/EmptyState';
import { usePageTitle } from '@/components/usePageTitle';
import { MissionsTable } from '@/features/missions/MissionsTable';

export const Route = createFileRoute('/_staff/staff/missions/')({ component: MissionsPage });

function MissionsPage() {
  const { t } = useTranslation('missions');
  usePageTitle(t('title'));
  const { data: missions, isPending } = useMissions();
  const { data: drones } = useMissionDrones();
  const droneNames = Object.fromEntries((drones ?? []).map((d) => [d.key, d.name]));
  return (
    <Stack gap="lg">
      <Group justify="space-between">
        <Title order={1}>{t('title')}</Title>
        <Button component={Link} to="/staff/missions/new">
          {t('new')}
        </Button>
      </Group>
      {isPending ? (
        <Center py="xl">
          <Loader color="forest" />
        </Center>
      ) : !missions?.length ? (
        <EmptyState title={t('empty')} />
      ) : (
        <MissionsTable missions={missions} droneNames={droneNames} />
      )}
    </Stack>
  );
}
